/** Legacy export — heal portrait FX now uses heal.png for 2s (see generalHealFlashEffect.js). */

import { GENERAL_HEAL_FLASH_DURATION_MS } from './generalHealFlashEffect';

export const VIRAL_ECHO_PLUS_STAGGER_MS = 95;
export const VIRAL_ECHO_PLUS_COUNT = 3;
export const VIRAL_ECHO_HEAL_FX_TOTAL_MS = GENERAL_HEAL_FLASH_DURATION_MS;

/** Red × marks on damaged general (strategems 185 / 188 / 220). */
export const VIRAL_ECHO_PLUS_IN_CIRCLE = [
  { angleDeg: -88, radiusFrac: 0.34 },
  { angleDeg: 152, radiusFrac: 0.36 },
  { angleDeg: 32, radiusFrac: 0.36 },
];
